export const UI_ACTIVE_MODAL_CHANGED = 'ui.ACTIVE_MODAL_CHANGED';
export const UI_SET_PREVIOUSLY_ACTIVE_MODAL = 'ui.SET_PREVIOUSLY_ACTIVE_MODAL';
export const UI_PROCUREMENT_DISMISSED_POWER_MODAL = 'ui.PROCUREMENT_DISMISSED_POWER_MODAL';
export const UI_SET_HR_POWER_MODAL_VISIBLE = 'ui.SET_HR_POWER_MODAL_VISIBLE';
export const UI_RESET_DISPLAYED_CASH_UPDATES = 'ui.RESET_DISPLAYED_CASH_UPDATES';
export const UI_ADD_EXPENSE_TO_DISPLAY = 'ui.ADD_EXPENSE_TO_DISPLAY';
export const UI_ADD_NEW_EXPENSE_TO_DISPLAY = 'ui.ADD_NEW_EXPENSE_TO_DISPLAY';
export const UI_ADD_INCOME_TO_DISPLAY = 'ui.ADD_INCOME_TO_DISPLAY';

export const UI_DRAGGABLE_COMPONENT_SHOW = 'ui.DRAGGABLE_COMPONENT_SHOW';

export const UI_LEVEL_NEW_MODAL_FOR_LEVEL_2_CLOSED = 'ui.LEVEL_NEW_MODAL_FOR_LEVEL_2_CLOSED';
export const UI_LEVEL_NEW_MODAL_FOR_LEVEL_3_CLOSED = 'ui.LEVEL_NEW_MODAL_FOR_LEVEL_3_CLOSED';
export const UI_UPDATE_SHOULD_SHOW_LEVEL_STORY = 'ui.UPDATE_SHOULD_SHOW_LEVEL_STORY';
export const UI_LEVEL_NEW_MODAL_CLOSED = 'ui.LEVEL_NEW_MODAL_CLOSED'
export const UI_PROCUREMENT_OPENED = 'ui.PROCUREMENT_OPENED';
export const UI_PROCUREMENT_CLOSED = 'ui.PROCUREMENT_CLOSED';
export const UI_PROCUREMENT_BUY_MODAL_OPENED = 'ui.PROCUREMENT_BUY_MODAL_OPENED';
export const UI_GAME_MENU_OPENED = 'ui.GAME_MENU_OPENED';
export const UI_GAME_MENU_CLOSED = 'ui.GAME_MENU_CLOSED';
export const UI_SET_GAME_MENU_RETURN_ROUTE = 'ui.SET_GAME_MENU_RETURN_ROUTE';
export const UI_LOGBOOK_OPENED = 'ui.LOGBOOK_OPENED';
export const UI_LOGBOOK_CLOSED = 'ui.LOGBOOK_CLOSED';
export const UI_LOGBOOK_GENERAL_TAB_CLOSED = 'ui.LOGBOOK_GENERAL_TAB_CLOSED';
export const UI_LOGBOOK_SALES_TAB_CLOSED = 'ui.LOGBOOK_SALES_TAB_CLOSED';
export const UI_LOGBOOK_PURCHASES_TAB_CLOSED = 'ui.LOGBOOK_PURCHASES_TAB_CLOSED';
export const UI_INBOX_OPENED = 'ui.INBOX_OPENED';
export const UI_INBOX_CLOSED = 'ui.INBOX_CLOSED';
export const UI_LEVELS_MODAL_OPENED = 'ui.LEVELS_MODAL_OPENED';
export const UI_LEVELS_MODAL_CLOSED = 'ui.LEVELS_MODAL_CLOSED';

export const UI_CUSTOMERS_ALL_HANDLED = 'ui.CUSTOMERS_ALL_HANDLED';

export const UI_PRODUCTS_PRODUCT_SELLING_PRICE_CHANGED
	= 'ui.PRODUCTS_PRODUCT_SELLING_PRICE_CHANGED';
	
export const UI_PRODUCTS_ALL_SELLING_PRICES_CHANGED = 'ui.PRODUCTS_ALL_SELLING_PRICES_CHANGED';

export const UI_PRODUCTS_CHANGED_2_PRODUCTS_NUMBER_TO_PURCHASE
	= 'ui.PRODUCTS_CHANGED_2_PRODUCTS_NUMBER_TO_PURCHASE';

export const UI_ACTIVE_COMPONENT_ADDED = 'ui.ACTIVE_COMPONENT_ADDED';
export const UI_ACTIVE_COMPONENT_REMOVED = 'ui.ACTIVE_COMPONENT_REMOVED';

export const UI_SHOW_INCOME_STATEMENT_TUTORIAL = 'ui.SHOW_INCOME_STATEMENT_TUTORIAL';
export const UI_HIDE_INCOME_STATEMENT_TUTORIAL = 'ui.HIDE_INCOME_STATEMENT_TUTORIAL';
export const UI_SHOW_BALANCE_SHEET_TUTORIAL = 'ui.SHOW_BALANCE_SHEET_TUTORIAL';
export const UI_HIDE_BALANCE_SHEET_TUTORIAL = 'ui.HIDE_BALANCE_SHEET_TUTORIAL';
export const UI_SHOW_FINANCIAL_RATIOS_TUTORIAL = 'ui.SHOW_FINANCIAL_RATIOS_TUTORIAL';
export const UI_HIDE_FINANCIAL_RATIOS_TUTORIAL = 'ui.HIDE_FINANCIAL_RATIOS_TUTORIAL';

export const UI_UPDATE_HAS_PENDING_CUSTOMER_TYPE_HINTS =
	'ui.UPDATE_HAS_PENDING_CUSTOMER_TYPE_TUTORIALS';
export const UI_SHOW_GLOW_ANIMATION = 'ui.SHOW_GLOW_ANIMATION';

export const UI_FETCHING_NETWORK_REQUEST = 'ui.FETCHING_NETWORK_REQUEST';
export const UI_SHOW_NETWORK_ERROR_MODAL = 'ui.SHOW_NETWORK_ERROR_MODAL';
export const UI_HIDE_NETWORK_ERROR_MODAL = 'ui.HIDE_NETWORK_ERROR_MODAL';

export const UI_SET_ACTIVE_CORKBOARD_TUTORIAL = 'ui.SET_ACTIVE_CORKBOARD_TUTORIAL';

export const UI_ENTER_LEVEL_FAILED_REVIEW_MODE = 'ui.ENTER_LEVEL_FAILED_REVIEW_MODE';
export const UI_EXIT_LEVEL_FAILED_REVIEW_MODE = 'ui.EXIT_LEVEL_FAILED_REVIEW_MODE';
